export default __webpack_public_path__ + "static/TeamIllustration-bb40326553e19713d3a75907438cb174.svg";